import { getRandomKey } from "../utils";
export var EventBus = /*#__PURE__*/function () {
  function EventBus() {
    this.eventBus = {};
    this.handleMap = {};
  }
  var _proto = EventBus.prototype;
  /** 制造一个事件 */
  _proto.emit = function emit(event, data) {
    var _this = this;
    if (this.eventBus[event]) {
      Object.keys(this.eventBus[event]).forEach(function (handleId) {
        _this.eventBus[event][handleId](data);
      });
    }
  }

  /** 取消一个订阅，如果传入句柄则取消某一个订阅 */;
  _proto.off = function off(eventOrHandleId) {
    if (this.eventBus[eventOrHandleId]) {
      delete this.eventBus[eventOrHandleId];
    } else {
      var event = this.handleMap[eventOrHandleId];
      if (event) {
        delete this.eventBus[event][eventOrHandleId];
        delete this.handleMap[eventOrHandleId];
      }
    }
  };
  _proto.on = function on(event, callback) {
    if (!this.eventBus[event]) {
      this.eventBus[event] = {};
    }
    var handleId = getRandomKey();
    this.eventBus[event][handleId] = callback;
    this.handleMap[handleId] = event;
    return handleId;
  };
  return EventBus;
}();